import { GetOrgSettings, GetServicerSettings, GetPublicServicerSettings, GetPublicPartnerSettings } from '../gql/leadGenQueries.gql'
import apolloClient from '~/util/apolloClient'
const { provider } = apolloClient()

export default {
  fetchOrgSettings (context) {
    const orgGuid = context.state.orgGuid
    const orgType = context.state.orgType
    const orgId = context.state.orgId
    if (!orgType || !(orgId || orgGuid)) return

    return provider.clients.defaultClient.query({
      query: GetOrgSettings,
      variables: { orgGuid, orgType, orgId }
    }).then(({ data: { publicData: { organization } } }) => {
      if (organization) {
        context.commit('setSettings', {
          landingPageTitle: organization?.lead_gen_setting_landing_page_title_text || null,
          orgIcon: organization?.effective_logo_url || null,
          orgAppIcon: organization?.effective_app_icon_url || null,
          name: organization?.name || null
        })
      } else {
        context.commit('reinitializeOrgSettings')
      }
    }).catch(() => {
      context.commit('reinitializeOrgSettings')
    })
  },
  fetchServicerSettings (context) {
    const servicerId = context.state.orgId
    if (!servicerId) return

    provider.clients.defaultClient.query({
      query: GetServicerSettings,
      variables: { id: servicerId }
    }).then(({ data: { servicer_profile } }) => {
      // eslint-disable-next-line babel/camelcase
      if (servicer_profile) {
        context.commit('setSettings', {
          orgIcon: servicer_profile.effective_company_logo_url,
          orgAppIcon: servicer_profile.effective_app_icon_url,
          servicerImageUrl: servicer_profile.profile_image_url,
          servicerInitials: servicer_profile.full_name.split(' ').map(name => name[0]).join(''),
          landingPageTitle: servicer_profile.lead_gen_setting_landing_page_title_text
        })
      } else {
        context.commit('reinitializeServicerSettings')
      }
    }).catch(() => {
      context.commit('reinitializeServicerSettings')
    })
  },
  fetchPublicServicerAndPartnerSettings (context) {
    const sac = context.state.sac
    if (!sac) return

    provider.clients.defaultClient.query({
      query: GetPublicServicerSettings,
      variables: { sac }
    }).then(({ data: { publicData: { servicer_profile } } }) => {
      // eslint-disable-next-line babel/camelcase
      if (servicer_profile) {
        context.commit('setSettings', {
          orgIcon: servicer_profile.effective_company_logo_url,
          orgAppIcon: servicer_profile.effective_app_icon_url,
          servicerImageUrl: servicer_profile.profile_image_url,
          servicerInitials: servicer_profile.full_name.split(' ').map(name => name[0]).join(''),
          landingPageTitle: servicer_profile.lead_gen_setting_landing_page_title_text
        })
      } else {
        context.commit('reinitializeServicerSettings')
      }
    }).catch(() => {
      context.commit('reinitializeServicerSettings')
    })

    context.dispatch('fetchPublicPartnerSettings', context)
  },
  fetchPublicPartnerSettings (context) {
    const sac = context.state.sac
    if (!sac) return

    provider.clients.defaultClient.query({
      query: GetPublicPartnerSettings,
      variables: { sac }
    }).then(({ data: { publicData: { partner } } }) => {
      if (partner) {
        context.commit('setPartnerSettings', {
          partnerImageUrl: partner.profile_image_url,
          partnerInitials: partner.full_name.split(' ').map(name => name[0]).join('')
        })
      } else {
        context.commit('reinitializePartnerSettings')
      }
    }).catch(() => {
      context.commit('reinitializePartnerSettings')
    })
  }
}
